import React, { useState } from "react";
import classes from "./attachModal.module.css";
import icons from "../../../../../Data/icons";
import { useMutation } from "react-query";
import { postNote } from "../../../../../MyApi/crm/tasks";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
const NoteModal = ({ data ,closeModal ,crm_task_id ,crm_task_list_id ,refetch}) => {  
  const [showAddNote ,setShowAddNote] =useState(false)
  const mutation =useMutation({mutationKey:["addnote"] ,mutationFn:(postData)=>postNote(postData) ,onSuccess:(data)=>{
  toast.success(`${data.message}`)
  setShowAddNote(false)
  refetch()
  }})
  const [note,setNote] =useState("")
  const [file,setFile] = useState("")
  const CloseIcon = icons.close;
  const AttachIcon = icons.attach
  const CommentICon = icons.comment
  const AddIcon = icons.add
  const notes =data?.data.notes || []
 const toggleAddNote = ()=>{
  setShowAddNote(!showAddNote)
 }
 const handelNoteChange=(e)=>{
  const {value}=e.target
  setNote(value)
 }
 const handleAttachments =(e)=>{
setFile(e.target.files[0])
 }
 const handelPostNote =()=>{
  const formData =new FormData()
  formData.append("crm_task_id" ,crm_task_id) 
  formData.append("crm_task_list_id" ,crm_task_list_id) 
  formData.append("note" ,note) 
  formData.append("file" ,file) 
  mutation.mutate(formData)
 }
  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
        <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseIcon />
          </button>
          <h2 className={classes.modalTitle}>تفاصيل الملاحظات</h2>
        </div>
        {!data ? (
  <div>no data available</div>
) : (
  notes.map((item) => (
    <div className={classes.modalBody} key={item.id}>
      <div class="user-profile">
      <div class="post-about card-body">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="icon">
             { item.file !== null ? <CommentICon /> : <AttachIcon/>}
            </div>
            <div>
              <h5 className="mb-1">{item.employe}</h5>
              <p>{item.note}</p>
            </div>
          </li>
        </ul>
        
      </div>
      </div>
    </div>
  ))

   
)}
<div className="p-3">
<div onClick={toggleAddNote} >
  <AddIcon/>
</div>

{showAddNote &&
<div>
  
<textarea type="text" className="form-control" onChange={handelNoteChange}></textarea>

 <input type="file"  className="form-control" onChange={handleAttachments}/>

<button type="button" className="btn btn-primary mt-2" onClick={handelPostNote}>{mutation.status ==="loading" ?<Spinner/>: "أضف ملاحظة  " 
}</button>
</div>
}
</div>





      </div>
    </div>
  );
};

export default NoteModal;
